import auth from '../services/auth.services';

// function sleep(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

export const login = (details) => async (dispatch) => {
  // await sleep(2000);

  dispatch({
    type: 'LOGIN',
    payload: details
  });
};
export const login_fail = () => async (dispatch) => {
  // await sleep(2000);

  dispatch({
    type: 'LOGIN'
    // payload: details
  });
};

export const logout = () => (dispatch) => {
  auth.deleteToken();
  auth.deleteUserInfo();
  dispatch({
    type: 'LOGOUT',
    payload: 'Manual Logout'
  });
  window.location.href = '/';
};

export const wakeUp = () => (dispatch) => {
  var t = auth.retriveToken() || null;
  if (t && t !== 'undefined') {
    auth
      .wakeUp(t)
      .then((res) => {
        dispatch({
          type: 'LOGIN',
          payload1: t,
          payload2: res.data.user
        });
      })
      .catch((err) => {
        if (err) {
          dispatch({
            type: 'LOGOUT',
            payload1: 'Token Expired'
          });
        }
      });
  } else {
    dispatch({
      type: 'LOGOUT',
      payload1: 'No Token'
    });
  }
};